// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/file/file.v2.proto (package no.jotta.openapi.file.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { BackgroundJob } from "../job/v1/job.v1_pb.js";
/**
 * @generated from enum no.jotta.openapi.file.v2.ItemType
 */
export var ItemType;
(function (ItemType) {
    /**
     * @generated from enum value: UNKNOWN_ITEM_TYPE = 0;
     */
    ItemType[ItemType["UNKNOWN_ITEM_TYPE"] = 0] = "UNKNOWN_ITEM_TYPE";
    /**
     * @generated from enum value: FILE = 1;
     */
    ItemType[ItemType["FILE"] = 1] = "FILE";
    /**
     * @generated from enum value: FOLDER = 2;
     */
    ItemType[ItemType["FOLDER"] = 2] = "FOLDER";
})(ItemType || (ItemType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ItemType)
proto3.util.setEnumType(ItemType, "no.jotta.openapi.file.v2.ItemType", [
    { no: 0, name: "UNKNOWN_ITEM_TYPE" },
    { no: 1, name: "FILE" },
    { no: 2, name: "FOLDER" },
]);
/**
 * @generated from enum no.jotta.openapi.file.v2.ItemKind
 */
export var ItemKind;
(function (ItemKind) {
    /**
     * @generated from enum value: UNKNOWN_ITEM_KIND = 0;
     */
    ItemKind[ItemKind["UNKNOWN_ITEM_KIND"] = 0] = "UNKNOWN_ITEM_KIND";
    /**
     * @generated from enum value: OTHER = 1;
     */
    ItemKind[ItemKind["OTHER"] = 1] = "OTHER";
    /**
     * The root path module, i.e. "/archive", "/sync" and "/backup".
     *
     * @generated from enum value: MODULE = 2;
     */
    ItemKind[ItemKind["MODULE"] = 2] = "MODULE";
    /**
     * @generated from enum value: REGULAR_FOLDER = 3;
     */
    ItemKind[ItemKind["REGULAR_FOLDER"] = 3] = "REGULAR_FOLDER";
    /**
     * @generated from enum value: VIDEO = 4;
     */
    ItemKind[ItemKind["VIDEO"] = 4] = "VIDEO";
    /**
     * @generated from enum value: AUDIO = 5;
     */
    ItemKind[ItemKind["AUDIO"] = 5] = "AUDIO";
    /**
     * @generated from enum value: IMAGE = 6;
     */
    ItemKind[ItemKind["IMAGE"] = 6] = "IMAGE";
    /**
     * @generated from enum value: TEXT = 7;
     */
    ItemKind[ItemKind["TEXT"] = 7] = "TEXT";
    /**
     * @generated from enum value: PDF = 8;
     */
    ItemKind[ItemKind["PDF"] = 8] = "PDF";
    /**
     * @generated from enum value: RICH_TEXT = 9;
     */
    ItemKind[ItemKind["RICH_TEXT"] = 9] = "RICH_TEXT";
    /**
     * @generated from enum value: DOCUMENT = 26;
     */
    ItemKind[ItemKind["DOCUMENT"] = 26] = "DOCUMENT";
    /**
     * @generated from enum value: WORD = 27;
     */
    ItemKind[ItemKind["WORD"] = 27] = "WORD";
    /**
     * @generated from enum value: SPREADSHEET = 10;
     */
    ItemKind[ItemKind["SPREADSHEET"] = 10] = "SPREADSHEET";
    /**
     * @generated from enum value: EXCEL = 28;
     */
    ItemKind[ItemKind["EXCEL"] = 28] = "EXCEL";
    /**
     * @generated from enum value: PRESENTATION = 11;
     */
    ItemKind[ItemKind["PRESENTATION"] = 11] = "PRESENTATION";
    /**
     * @generated from enum value: POWERPOINT = 29;
     */
    ItemKind[ItemKind["POWERPOINT"] = 29] = "POWERPOINT";
    /**
     * @generated from enum value: HTML = 12;
     */
    ItemKind[ItemKind["HTML"] = 12] = "HTML";
    /**
     * @generated from enum value: ARCHIVE_KIND = 13;
     */
    ItemKind[ItemKind["ARCHIVE_KIND"] = 13] = "ARCHIVE_KIND";
    /**
     * @generated from enum value: COLLABORATION_FOLDER = 14;
     */
    ItemKind[ItemKind["COLLABORATION_FOLDER"] = 14] = "COLLABORATION_FOLDER";
    /**
     * @generated from enum value: WORKSTATION = 15;
     */
    ItemKind[ItemKind["WORKSTATION"] = 15] = "WORKSTATION";
    /**
     * @generated from enum value: LAPTOP = 16;
     */
    ItemKind[ItemKind["LAPTOP"] = 16] = "LAPTOP";
    /**
     * @generated from enum value: MACBOOK = 17;
     */
    ItemKind[ItemKind["MACBOOK"] = 17] = "MACBOOK";
    /**
     * @generated from enum value: IMAC = 18;
     */
    ItemKind[ItemKind["IMAC"] = 18] = "IMAC";
    /**
     * @generated from enum value: MACPRO = 19;
     */
    ItemKind[ItemKind["MACPRO"] = 19] = "MACPRO";
    /**
     * @generated from enum value: IPHONE = 20;
     */
    ItemKind[ItemKind["IPHONE"] = 20] = "IPHONE";
    /**
     * @generated from enum value: IPAD = 21;
     */
    ItemKind[ItemKind["IPAD"] = 21] = "IPAD";
    /**
     * @generated from enum value: ANDROID = 22;
     */
    ItemKind[ItemKind["ANDROID"] = 22] = "ANDROID";
    /**
     * @generated from enum value: WINDOWS_PHONE = 23;
     */
    ItemKind[ItemKind["WINDOWS_PHONE"] = 23] = "WINDOWS_PHONE";
    /**
     * @generated from enum value: WINDOWS_TABLET = 24;
     */
    ItemKind[ItemKind["WINDOWS_TABLET"] = 24] = "WINDOWS_TABLET";
    /**
     * @generated from enum value: CLI = 25;
     */
    ItemKind[ItemKind["CLI"] = 25] = "CLI";
})(ItemKind || (ItemKind = {}));
// Retrieve enum metadata with: proto3.getEnumType(ItemKind)
proto3.util.setEnumType(ItemKind, "no.jotta.openapi.file.v2.ItemKind", [
    { no: 0, name: "UNKNOWN_ITEM_KIND" },
    { no: 1, name: "OTHER" },
    { no: 2, name: "MODULE" },
    { no: 3, name: "REGULAR_FOLDER" },
    { no: 4, name: "VIDEO" },
    { no: 5, name: "AUDIO" },
    { no: 6, name: "IMAGE" },
    { no: 7, name: "TEXT" },
    { no: 8, name: "PDF" },
    { no: 9, name: "RICH_TEXT" },
    { no: 26, name: "DOCUMENT" },
    { no: 27, name: "WORD" },
    { no: 10, name: "SPREADSHEET" },
    { no: 28, name: "EXCEL" },
    { no: 11, name: "PRESENTATION" },
    { no: 29, name: "POWERPOINT" },
    { no: 12, name: "HTML" },
    { no: 13, name: "ARCHIVE_KIND" },
    { no: 14, name: "COLLABORATION_FOLDER" },
    { no: 15, name: "WORKSTATION" },
    { no: 16, name: "LAPTOP" },
    { no: 17, name: "MACBOOK" },
    { no: 18, name: "IMAC" },
    { no: 19, name: "MACPRO" },
    { no: 20, name: "IPHONE" },
    { no: 21, name: "IPAD" },
    { no: 22, name: "ANDROID" },
    { no: 23, name: "WINDOWS_PHONE" },
    { no: 24, name: "WINDOWS_TABLET" },
    { no: 25, name: "CLI" },
]);
/**
 * @generated from enum no.jotta.openapi.file.v2.ItemAction
 */
export var ItemAction;
(function (ItemAction) {
    /**
     * @generated from enum value: UNKNOWN_FILE_ACTION = 0;
     */
    ItemAction[ItemAction["UNKNOWN_FILE_ACTION"] = 0] = "UNKNOWN_FILE_ACTION";
    /**
     * @generated from enum value: ADD_CHILD = 1;
     */
    ItemAction[ItemAction["ADD_CHILD"] = 1] = "ADD_CHILD";
    /**
     * @generated from enum value: COPY = 2;
     */
    ItemAction[ItemAction["COPY"] = 2] = "COPY";
    /**
     * @generated from enum value: MOVE = 3;
     */
    ItemAction[ItemAction["MOVE"] = 3] = "MOVE";
    /**
     * @generated from enum value: DELETE = 4;
     */
    ItemAction[ItemAction["DELETE"] = 4] = "DELETE";
    /**
     * @generated from enum value: RESTORE = 5;
     */
    ItemAction[ItemAction["RESTORE"] = 5] = "RESTORE";
    /**
     * @generated from enum value: PERMANENTLY_DELETE = 6;
     */
    ItemAction[ItemAction["PERMANENTLY_DELETE"] = 6] = "PERMANENTLY_DELETE";
    /**
     * @generated from enum value: PUBLIC_SHARE = 7;
     */
    ItemAction[ItemAction["PUBLIC_SHARE"] = 7] = "PUBLIC_SHARE";
    /**
     * @generated from enum value: PUBLIC_UNSHARE = 8;
     */
    ItemAction[ItemAction["PUBLIC_UNSHARE"] = 8] = "PUBLIC_UNSHARE";
    /**
     * @generated from enum value: UPDATE = 9;
     */
    ItemAction[ItemAction["UPDATE"] = 9] = "UPDATE";
})(ItemAction || (ItemAction = {}));
// Retrieve enum metadata with: proto3.getEnumType(ItemAction)
proto3.util.setEnumType(ItemAction, "no.jotta.openapi.file.v2.ItemAction", [
    { no: 0, name: "UNKNOWN_FILE_ACTION" },
    { no: 1, name: "ADD_CHILD" },
    { no: 2, name: "COPY" },
    { no: 3, name: "MOVE" },
    { no: 4, name: "DELETE" },
    { no: 5, name: "RESTORE" },
    { no: 6, name: "PERMANENTLY_DELETE" },
    { no: 7, name: "PUBLIC_SHARE" },
    { no: 8, name: "PUBLIC_UNSHARE" },
    { no: 9, name: "UPDATE" },
]);
/**
 * @generated from enum no.jotta.openapi.file.v2.FileState
 */
export var FileState;
(function (FileState) {
    /**
     * @generated from enum value: UNKNOWN_FILE_STATE = 0;
     */
    FileState[FileState["UNKNOWN_FILE_STATE"] = 0] = "UNKNOWN_FILE_STATE";
    /**
     * File and metadata is allocated and ready for upload.
     *
     * @generated from enum value: ADDED = 1;
     */
    FileState[FileState["ADDED"] = 1] = "ADDED";
    /**
     * File is partially uploaded and can be resumed. Note that even files with 0 bytes uploaded will have this state.
     * Client can choose to resume the file upload from the resume_position given in the response.
     *
     * @generated from enum value: INCOMPLETE = 2;
     */
    FileState[FileState["INCOMPLETE"] = 2] = "INCOMPLETE";
    /**
     * Corrupt means the allocated file is corrupt. Should not happen for new allocations.
     *
     * @generated from enum value: CORRUPT = 3;
     */
    FileState[FileState["CORRUPT"] = 3] = "CORRUPT";
    /**
     * Not in active use.
     *
     * @generated from enum value: PROCESSING = 4;
     */
    FileState[FileState["PROCESSING"] = 4] = "PROCESSING";
    /**
     * File with the given path is already uploaded and complete. Upload not necessary.
     *
     * @generated from enum value: COMPLETED = 5;
     */
    FileState[FileState["COMPLETED"] = 5] = "COMPLETED";
})(FileState || (FileState = {}));
// Retrieve enum metadata with: proto3.getEnumType(FileState)
proto3.util.setEnumType(FileState, "no.jotta.openapi.file.v2.FileState", [
    { no: 0, name: "UNKNOWN_FILE_STATE" },
    { no: 1, name: "ADDED" },
    { no: 2, name: "INCOMPLETE" },
    { no: 3, name: "CORRUPT" },
    { no: 4, name: "PROCESSING" },
    { no: 5, name: "COMPLETED" },
]);
/**
 * @generated from enum no.jotta.openapi.file.v2.AllocateConflictHandler
 */
export var AllocateConflictHandler;
(function (AllocateConflictHandler) {
    /**
     * Will return a conflict error response if the file already exists with a different checksum.
     *
     * @generated from enum value: REJECT_CONFLICTS = 0;
     */
    AllocateConflictHandler[AllocateConflictHandler["REJECT_CONFLICTS"] = 0] = "REJECT_CONFLICTS";
    /**
     * Will allocate a new revision of the file.
     *
     * @generated from enum value: CREATE_NEW_REVISION = 1;
     */
    AllocateConflictHandler[AllocateConflictHandler["CREATE_NEW_REVISION"] = 1] = "CREATE_NEW_REVISION";
    /**
     * Will create a new file with an unique name by adding postfix _(1)_ or similar to the file name.
     * Check the name in the response.
     *
     * @generated from enum value: CREATE_NEW_FILE = 2;
     */
    AllocateConflictHandler[AllocateConflictHandler["CREATE_NEW_FILE"] = 2] = "CREATE_NEW_FILE";
})(AllocateConflictHandler || (AllocateConflictHandler = {}));
// Retrieve enum metadata with: proto3.getEnumType(AllocateConflictHandler)
proto3.util.setEnumType(AllocateConflictHandler, "no.jotta.openapi.file.v2.AllocateConflictHandler", [
    { no: 0, name: "REJECT_CONFLICTS" },
    { no: 1, name: "CREATE_NEW_REVISION" },
    { no: 2, name: "CREATE_NEW_FILE" },
]);
/**
 * @generated from enum no.jotta.openapi.file.v2.FileSystemError
 */
export var FileSystemError;
(function (FileSystemError) {
    /**
     * @generated from enum value: UNKNOWN_FILE_SYSTEM_ERROR = 0;
     */
    FileSystemError[FileSystemError["UNKNOWN_FILE_SYSTEM_ERROR"] = 0] = "UNKNOWN_FILE_SYSTEM_ERROR";
    /**
     * @generated from enum value: READ_LOCKED = 1;
     */
    FileSystemError[FileSystemError["READ_LOCKED"] = 1] = "READ_LOCKED";
    /**
     * @generated from enum value: WRITE_LOCKED = 2;
     */
    FileSystemError[FileSystemError["WRITE_LOCKED"] = 2] = "WRITE_LOCKED";
    /**
     * @generated from enum value: INSUFFICIENT_CAPACITY = 3;
     */
    FileSystemError[FileSystemError["INSUFFICIENT_CAPACITY"] = 3] = "INSUFFICIENT_CAPACITY";
})(FileSystemError || (FileSystemError = {}));
// Retrieve enum metadata with: proto3.getEnumType(FileSystemError)
proto3.util.setEnumType(FileSystemError, "no.jotta.openapi.file.v2.FileSystemError", [
    { no: 0, name: "UNKNOWN_FILE_SYSTEM_ERROR" },
    { no: 1, name: "READ_LOCKED" },
    { no: 2, name: "WRITE_LOCKED" },
    { no: 3, name: "INSUFFICIENT_CAPACITY" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.PathItem
 */
export class PathItem extends Message {
    /**
     * Full Jottacloud path of this item.
     *
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * Name of the item, e.g. file name or folder name.
     *
     * @generated from field: string name = 2;
     */
    name = "";
    /**
     * Kind is a presentation friendly name, useful for UI icons or similar.
     *
     * @generated from field: no.jotta.openapi.file.v2.ItemKind kind = 3;
     */
    kind = ItemKind.UNKNOWN_ITEM_KIND;
    /**
     * Type is File or Folder. Only Folders can have children.
     *
     * @generated from field: no.jotta.openapi.file.v2.ItemType type = 4;
     */
    type = ItemType.UNKNOWN_ITEM_TYPE;
    /**
     * A link to where you can download this item, if possible.
     *
     * @generated from field: string download_link = 6;
     */
    downloadLink = "";
    /**
     * The size of this item in bytes. Only available for files.
     *
     * @generated from field: int64 size = 7;
     */
    size = protoInt64.zero;
    /**
     * The md5 checksum of this item. Only available for files.
     *
     * @generated from field: string checksum = 8;
     */
    checksum = "";
    /**
     * @generated from field: int64 created_at_millis = 9;
     */
    createdAtMillis = protoInt64.zero;
    /**
     * @generated from field: int64 modified_at_millis = 10;
     */
    modifiedAtMillis = protoInt64.zero;
    /**
     * Deleted at value of 0 means not deleted.
     *
     * @generated from field: int64 deleted_at_millis = 11;
     */
    deletedAtMillis = protoInt64.zero;
    /**
     * Mime is the mimetype for this item
     *
     * @generated from field: string mime = 12;
     */
    mime = "";
    /**
     * @generated from field: repeated no.jotta.openapi.file.v2.PathItem children = 13;
     */
    children = [];
    /**
     * @generated from field: string public_link_id = 14;
     */
    publicLinkId = "";
    /**
     * Actions is a list of actions available for this item.
     *
     * @generated from field: repeated no.jotta.openapi.file.v2.ItemAction action = 15;
     */
    action = [];
    /**
     * Link to a thumbnail if supported for this item.
     *
     * @generated from field: string thumb_link = 16;
     */
    thumbLink = "";
    /**
     * @generated from field: string comment_item_id = 17;
     */
    commentItemId = "";
    /**
     * @generated from field: string comment_auth_token = 18;
     */
    commentAuthToken = "";
    /**
     * @generated from field: string owner = 19;
     */
    owner = "";
    /**
     * @generated from field: string folder_share_id = 20;
     */
    folderShareId = "";
    /**
     * @generated from field: string encoded_content_ref = 21;
     */
    encodedContentRef = "";
    /**
     * @generated from field: string content_id = 22;
     */
    contentId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.PathItem";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "kind", kind: "enum", T: proto3.getEnumType(ItemKind) },
        { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(ItemType) },
        { no: 6, name: "download_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 8, name: "checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 9, name: "created_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 10, name: "modified_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 11, name: "deleted_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 12, name: "mime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 13, name: "children", kind: "message", T: PathItem, repeated: true },
        { no: 14, name: "public_link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 15, name: "action", kind: "enum", T: proto3.getEnumType(ItemAction), repeated: true },
        { no: 16, name: "thumb_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 17, name: "comment_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 18, name: "comment_auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 19, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 20, name: "folder_share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 21, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 22, name: "content_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PathItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PathItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PathItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PathItem, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.FormParameter
 */
export class FormParameter extends Message {
    /**
     * @generated from field: string name = 1;
     */
    name = "";
    /**
     * @generated from field: string value = 2;
     */
    value = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.FormParameter";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new FormParameter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FormParameter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FormParameter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FormParameter, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.DownloadZipResponse
 */
export class DownloadZipResponse extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    /**
     * @generated from field: string method = 2;
     */
    method = "";
    /**
     * @generated from field: string body = 3;
     */
    body = "";
    /**
     * @generated from field: repeated no.jotta.openapi.file.v2.FormParameter parameter = 4;
     */
    parameter = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.DownloadZipResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "parameter", kind: "message", T: FormParameter, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadZipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadZipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadZipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadZipResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.DownloadZipRequest
 */
export class DownloadZipRequest extends Message {
    /**
     * @generated from field: repeated string path = 1;
     */
    path = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.DownloadZipRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadZipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadZipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadZipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadZipRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.FileRevision
 */
export class FileRevision extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: string url = 2;
     */
    url = "";
    /**
     * @generated from field: int64 size = 3;
     */
    size = protoInt64.zero;
    /**
     * @generated from field: string checksum = 4;
     */
    checksum = "";
    /**
     * @generated from field: int64 created_at_millis = 5;
     */
    createdAtMillis = protoInt64.zero;
    /**
     * @generated from field: int64 modified_at_millis = 6;
     */
    modifiedAtMillis = protoInt64.zero;
    /**
     * @generated from field: string encoded_content_ref = 7;
     */
    encodedContentRef = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.FileRevision";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "created_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 6, name: "modified_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 7, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new FileRevision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileRevision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileRevision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileRevision, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.RetryAfterError
 */
export class RetryAfterError extends Message {
    /**
     * @generated from field: uint64 retry_after_millis = 1;
     */
    retryAfterMillis = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.RetryAfterError";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "retry_after_millis", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new RetryAfterError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetryAfterError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetryAfterError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetryAfterError, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.InvalidPathError
 */
export class InvalidPathError extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.InvalidPathError";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new InvalidPathError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InvalidPathError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InvalidPathError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InvalidPathError, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.GetPathRequest
 */
export class GetPathRequest extends Message {
    /**
     * The path to get. '/' is a good starting point.
     *
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: no.jotta.openapi.file.v2.GetPathRequest.Sort sort = 2;
     */
    sort = GetPathRequest_Sort.UNKNOWN;
    /**
     * Limit is the maximum number of results to return per request
     *
     * @generated from field: uint32 limit = 3;
     */
    limit = 0;
    /**
     * Include children in response when the path is a folder.
     *
     * @generated from field: bool include_children = 4;
     */
    includeChildren = false;
    /**
     * Also include deleted (trashed) files and folders in the response.
     *
     * @generated from field: bool include_deleted = 5;
     */
    includeDeleted = false;
    /**
     * Use a cursor from GetPathResponse to get the next part of the result set.
     *
     * @generated from field: string cursor = 6;
     */
    cursor = "";
    /**
     * Include a cursor per child item when the path is a folder.
     *
     * @generated from field: bool include_children_cursors = 8;
     */
    includeChildrenCursors = false;
    /**
     * Response will include a thumbnail link if supported.
     *
     * @generated from field: bool include_thumb = 7;
     */
    includeThumb = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.GetPathRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "sort", kind: "enum", T: proto3.getEnumType(GetPathRequest_Sort) },
        { no: 3, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 4, name: "include_children", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 5, name: "include_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 6, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "include_children_cursors", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 7, name: "include_thumb", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetPathRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPathRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPathRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPathRequest, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.GetPathRequest.Sort
 */
export var GetPathRequest_Sort;
(function (GetPathRequest_Sort) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: NAME_ASC = 1;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["NAME_ASC"] = 1] = "NAME_ASC";
    /**
     * @generated from enum value: NAME_DESC = 2;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["NAME_DESC"] = 2] = "NAME_DESC";
    /**
     * @generated from enum value: DATE_ASC = 3;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["DATE_ASC"] = 3] = "DATE_ASC";
    /**
     * @generated from enum value: DATE_DESC = 4;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["DATE_DESC"] = 4] = "DATE_DESC";
    /**
     * @generated from enum value: SIZE_ASC = 5;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["SIZE_ASC"] = 5] = "SIZE_ASC";
    /**
     * @generated from enum value: SIZE_DESC = 6;
     */
    GetPathRequest_Sort[GetPathRequest_Sort["SIZE_DESC"] = 6] = "SIZE_DESC";
})(GetPathRequest_Sort || (GetPathRequest_Sort = {}));
// Retrieve enum metadata with: proto3.getEnumType(GetPathRequest_Sort)
proto3.util.setEnumType(GetPathRequest_Sort, "no.jotta.openapi.file.v2.GetPathRequest.Sort", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "NAME_ASC" },
    { no: 2, name: "NAME_DESC" },
    { no: 3, name: "DATE_ASC" },
    { no: 4, name: "DATE_DESC" },
    { no: 5, name: "SIZE_ASC" },
    { no: 6, name: "SIZE_DESC" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.GetPathResponse
 */
export class GetPathResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem path_item = 1;
     */
    pathItem;
    /**
     * @generated from field: string cursor = 2;
     */
    cursor = "";
    /**
     * If path_item is a folder and include_children_cursors in the request is true, contains the individual cursors per
     * child item in a list parallel to path_item.children.
     *
     * @generated from field: repeated string child_cursor = 3;
     */
    childCursor = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.GetPathResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path_item", kind: "message", T: PathItem },
        { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "child_cursor", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetPathResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPathResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPathResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPathResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.AllocateRequest
 */
export class AllocateRequest extends Message {
    /**
     * Full path to location where you want the file - including the file name.
     *
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * The calculated md5 checksum of the entire file.
     * Used to verify the integrity of the file. The md5 is also used to check if the file is already uploaded by this user and if it is, do an internal copy on server-side.
     *
     * @generated from field: string md5 = 2;
     */
    md5 = "";
    /**
     * The size of the file in bytes. The specified size will be used to verify the upload is complete.
     *
     * @generated from field: int64 size = 3;
     */
    size = protoInt64.zero;
    /**
     * The creation timestamp of the file in millis
     *
     * @generated from field: int64 created_at_millis = 4;
     */
    createdAtMillis = protoInt64.zero;
    /**
     * The last modified timestamp of the file in millis
     *
     * @generated from field: int64 modified_at_millis = 5;
     */
    modifiedAtMillis = protoInt64.zero;
    /**
     * Conflict handler tells the system how to handle conflicting files in the path.
     * I.e. allocations to a path where the file already exists.
     * Note that if the given path already exists as a folder this method will always yield a conflict error regardless of this parameter.
     *
     * @generated from field: no.jotta.openapi.file.v2.AllocateConflictHandler conflict_handler = 6;
     */
    conflictHandler = AllocateConflictHandler.REJECT_CONFLICTS;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.AllocateRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "md5", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "created_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 5, name: "modified_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 6, name: "conflict_handler", kind: "enum", T: proto3.getEnumType(AllocateConflictHandler) },
    ]);
    static fromBinary(bytes, options) {
        return new AllocateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AllocateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AllocateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AllocateRequest, a, b);
    }
}
/**
 * AllocateResponse contains the result of an allocation operation.
 *
 * @generated from message no.jotta.openapi.file.v2.AllocateResponse
 */
export class AllocateResponse extends Message {
    /**
     * Name of the allocated file
     *
     * @generated from field: string name = 1;
     */
    name = "";
    /**
     * Path of the allocated file
     *
     * @generated from field: string path = 2;
     */
    path = "";
    /**
     * The state of the file after the allocation is run.
     *
     * @generated from field: no.jotta.openapi.file.v2.FileState state = 3;
     */
    state = FileState.UNKNOWN_FILE_STATE;
    /**
     * A unique id for this upload operation. Can be useful for logging etc.
     *
     * @generated from field: string upload_id = 4;
     */
    uploadId = "";
    /**
     * Upload url is an absolute url to the server which will receive the file upload.
     *
     * @generated from field: string upload_url = 5;
     */
    uploadUrl = "";
    /**
     * Bytes is echo of the allocated file size.
     *
     * @generated from field: int64 bytes = 6;
     */
    bytes = protoInt64.zero;
    /**
     * If file state is "INCOMPLETE", the file can be resumed starting at this byte.
     * Note that position 0 also is valid and means from the beginning of file.
     * File uploads can be resumed using the Range header, see section about File Upload for details.
     *
     * @generated from field: int64 resume_position = 7;
     */
    resumePosition = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.AllocateResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "state", kind: "enum", T: proto3.getEnumType(FileState) },
        { no: 4, name: "upload_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "upload_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 7, name: "resume_position", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new AllocateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AllocateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AllocateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AllocateResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.AllocateResponse.AllocateError
 */
export var AllocateResponse_AllocateError;
(function (AllocateResponse_AllocateError) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    AllocateResponse_AllocateError[AllocateResponse_AllocateError["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Allocated file on a path where a folder already exists.
     *
     * @generated from enum value: ALLOCATE_FILE_ONTO_FOLDER = 1;
     */
    AllocateResponse_AllocateError[AllocateResponse_AllocateError["ALLOCATE_FILE_ONTO_FOLDER"] = 1] = "ALLOCATE_FILE_ONTO_FOLDER";
    /**
     * Allocated file on a path where a file already exists.
     *
     * @generated from enum value: ALLOCATE_FILE_ONTO_FILE = 2;
     */
    AllocateResponse_AllocateError[AllocateResponse_AllocateError["ALLOCATE_FILE_ONTO_FILE"] = 2] = "ALLOCATE_FILE_ONTO_FILE";
    /**
     * Not a valid destination such as /Sync /Archive etc
     *
     * @generated from enum value: ALLOCATE_INVALID_DESTINATION = 3;
     */
    AllocateResponse_AllocateError[AllocateResponse_AllocateError["ALLOCATE_INVALID_DESTINATION"] = 3] = "ALLOCATE_INVALID_DESTINATION";
    /**
     * File content is illegal according to our content safety policy
     *
     * @generated from enum value: ALLOCATE_FILE_WITH_ILLEGAL_CONTENT = 4;
     */
    AllocateResponse_AllocateError[AllocateResponse_AllocateError["ALLOCATE_FILE_WITH_ILLEGAL_CONTENT"] = 4] = "ALLOCATE_FILE_WITH_ILLEGAL_CONTENT";
})(AllocateResponse_AllocateError || (AllocateResponse_AllocateError = {}));
// Retrieve enum metadata with: proto3.getEnumType(AllocateResponse_AllocateError)
proto3.util.setEnumType(AllocateResponse_AllocateError, "no.jotta.openapi.file.v2.AllocateResponse.AllocateError", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ALLOCATE_FILE_ONTO_FOLDER" },
    { no: 2, name: "ALLOCATE_FILE_ONTO_FILE" },
    { no: 3, name: "ALLOCATE_INVALID_DESTINATION" },
    { no: 4, name: "ALLOCATE_FILE_WITH_ILLEGAL_CONTENT" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage
 */
export class AllocateResponse_AllocateErrorMessage extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.error
     */
    error = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "allocate_error", kind: "enum", T: proto3.getEnumType(AllocateResponse_AllocateError), oneof: "error" },
        { no: 2, name: "file_system_error", kind: "enum", T: proto3.getEnumType(FileSystemError), oneof: "error" },
        { no: 3, name: "retry_after_error", kind: "message", T: RetryAfterError, oneof: "error" },
        { no: 4, name: "invalid_path_error", kind: "message", T: InvalidPathError, oneof: "error" },
    ]);
    static fromBinary(bytes, options) {
        return new AllocateResponse_AllocateErrorMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AllocateResponse_AllocateErrorMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AllocateResponse_AllocateErrorMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AllocateResponse_AllocateErrorMessage, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.SearchRequest
 */
export class SearchRequest extends Message {
    /**
     * repeated Location locations = 2;
     *
     * @generated from field: string query = 1;
     */
    query = "";
    /**
     * narrow search to specific paths. If left empty, the search is global
     *
     * @generated from field: repeated string path = 5;
     */
    path = [];
    /**
     * @generated from field: int32 page_index = 3;
     */
    pageIndex = 0;
    /**
     * @generated from field: int32 page_size = 4;
     */
    pageSize = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.SearchRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 3, name: "page_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new SearchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.SearchResponse
 */
export class SearchResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem match = 1;
     */
    match;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.SearchResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "match", kind: "message", T: PathItem },
    ]);
    static fromBinary(bytes, options) {
        return new SearchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.CreateFolderRequest
 */
export class CreateFolderRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler conflict_handler = 2;
     */
    conflictHandler = CreateFolderRequest_ConflictHandler.UNKNOWN;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.CreateFolderRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "conflict_handler", kind: "enum", T: proto3.getEnumType(CreateFolderRequest_ConflictHandler) },
    ]);
    static fromBinary(bytes, options) {
        return new CreateFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateFolderRequest, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler
 */
export var CreateFolderRequest_ConflictHandler;
(function (CreateFolderRequest_ConflictHandler) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    CreateFolderRequest_ConflictHandler[CreateFolderRequest_ConflictHandler["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: REUSE_EXISTING_FOLDER = 1;
     */
    CreateFolderRequest_ConflictHandler[CreateFolderRequest_ConflictHandler["REUSE_EXISTING_FOLDER"] = 1] = "REUSE_EXISTING_FOLDER";
    /**
     * Reject will throw a error when there is a conflict on the target path
     *
     * @generated from enum value: REJECT_CONFLICTS = 2;
     */
    CreateFolderRequest_ConflictHandler[CreateFolderRequest_ConflictHandler["REJECT_CONFLICTS"] = 2] = "REJECT_CONFLICTS";
    /**
     * @generated from enum value: CREATE_NEW_FOLDER = 3;
     */
    CreateFolderRequest_ConflictHandler[CreateFolderRequest_ConflictHandler["CREATE_NEW_FOLDER"] = 3] = "CREATE_NEW_FOLDER";
})(CreateFolderRequest_ConflictHandler || (CreateFolderRequest_ConflictHandler = {}));
// Retrieve enum metadata with: proto3.getEnumType(CreateFolderRequest_ConflictHandler)
proto3.util.setEnumType(CreateFolderRequest_ConflictHandler, "no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "REUSE_EXISTING_FOLDER" },
    { no: 2, name: "REJECT_CONFLICTS" },
    { no: 3, name: "CREATE_NEW_FOLDER" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.CreateFolderResponse
 */
export class CreateFolderResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem folder = 1;
     */
    folder;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.CreateFolderResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder", kind: "message", T: PathItem },
    ]);
    static fromBinary(bytes, options) {
        return new CreateFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateFolderResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.CreateFolderResponse.CreateFolderError
 */
export var CreateFolderResponse_CreateFolderError;
(function (CreateFolderResponse_CreateFolderError) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    CreateFolderResponse_CreateFolderError[CreateFolderResponse_CreateFolderError["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: TARGET_IS_A_FILE = 1;
     */
    CreateFolderResponse_CreateFolderError[CreateFolderResponse_CreateFolderError["TARGET_IS_A_FILE"] = 1] = "TARGET_IS_A_FILE";
})(CreateFolderResponse_CreateFolderError || (CreateFolderResponse_CreateFolderError = {}));
// Retrieve enum metadata with: proto3.getEnumType(CreateFolderResponse_CreateFolderError)
proto3.util.setEnumType(CreateFolderResponse_CreateFolderError, "no.jotta.openapi.file.v2.CreateFolderResponse.CreateFolderError", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "TARGET_IS_A_FILE" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.MoveRequest
 */
export class MoveRequest extends Message {
    /**
     * @generated from field: string from_path = 1;
     */
    fromPath = "";
    /**
     * @generated from field: string to_path = 2;
     */
    toPath = "";
    /**
     * @generated from field: no.jotta.openapi.file.v2.MoveRequest.ConflictHandler conflict_handler = 3;
     */
    conflictHandler = MoveRequest_ConflictHandler.UNKNOWN;
    /**
     * @generated from field: bool supports_background_jobs = 4;
     */
    supportsBackgroundJobs = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.MoveRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "from_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "to_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "conflict_handler", kind: "enum", T: proto3.getEnumType(MoveRequest_ConflictHandler) },
        { no: 4, name: "supports_background_jobs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new MoveRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveRequest, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.MoveRequest.ConflictHandler
 */
export var MoveRequest_ConflictHandler;
(function (MoveRequest_ConflictHandler) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    MoveRequest_ConflictHandler[MoveRequest_ConflictHandler["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Rejecting conflicts in path names is the default
     *
     * @generated from enum value: REJECT_CONFLICTS = 1;
     */
    MoveRequest_ConflictHandler[MoveRequest_ConflictHandler["REJECT_CONFLICTS"] = 1] = "REJECT_CONFLICTS";
    /**
     * Creates a new name that is unique when the to_path already exists.
     *
     * @generated from enum value: CREATE_NEW_NAME = 2;
     */
    MoveRequest_ConflictHandler[MoveRequest_ConflictHandler["CREATE_NEW_NAME"] = 2] = "CREATE_NEW_NAME";
    /**
     * Copy the latest revision from from_path onto to_path and put from_path in trash.
     *
     * @generated from enum value: CREATE_NEW_REVISION = 3;
     */
    MoveRequest_ConflictHandler[MoveRequest_ConflictHandler["CREATE_NEW_REVISION"] = 3] = "CREATE_NEW_REVISION";
})(MoveRequest_ConflictHandler || (MoveRequest_ConflictHandler = {}));
// Retrieve enum metadata with: proto3.getEnumType(MoveRequest_ConflictHandler)
proto3.util.setEnumType(MoveRequest_ConflictHandler, "no.jotta.openapi.file.v2.MoveRequest.ConflictHandler", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "REJECT_CONFLICTS" },
    { no: 2, name: "CREATE_NEW_NAME" },
    { no: 3, name: "CREATE_NEW_REVISION" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.MoveResponse
 */
export class MoveResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.MoveResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.MoveResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path_item", kind: "message", T: PathItem, oneof: "result" },
        { no: 2, name: "background_job", kind: "message", T: BackgroundJob, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new MoveResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.MoveResponse.MoveError
 */
export var MoveResponse_MoveError;
(function (MoveResponse_MoveError) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Moved folder into a path that is already a file.
     *
     * @generated from enum value: MOVE_FOLDER_ONTO_FILE = 1;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_FOLDER_ONTO_FILE"] = 1] = "MOVE_FOLDER_ONTO_FILE";
    /**
     * Moved folder into a path that is already a folder.
     *
     * @generated from enum value: MOVE_FOLDER_ONTO_FOLDER = 8;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_FOLDER_ONTO_FOLDER"] = 8] = "MOVE_FOLDER_ONTO_FOLDER";
    /**
     * Moved file into a path where a folder already exists.
     *
     * @generated from enum value: MOVE_FILE_ONTO_FOLDER = 2;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_FILE_ONTO_FOLDER"] = 2] = "MOVE_FILE_ONTO_FOLDER";
    /**
     * Moved file into a path where a file already exists.
     *
     * @generated from enum value: MOVE_FILE_ONTO_FILE = 9;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_FILE_ONTO_FILE"] = 9] = "MOVE_FILE_ONTO_FILE";
    /**
     * Move between users in an unsupported way.
     *
     * @generated from enum value: MOVE_BETWEEN_USERS = 3;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_BETWEEN_USERS"] = 3] = "MOVE_BETWEEN_USERS";
    /**
     * The paths given are equal.
     *
     * @generated from enum value: MOVE_TO_FROM_ARE_EQUAL = 4;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_TO_FROM_ARE_EQUAL"] = 4] = "MOVE_TO_FROM_ARE_EQUAL";
    /**
     * A recursive move into itself is unsupported.
     *
     * @generated from enum value: MOVE_FOLDER_INTO_ITSELF = 5;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_FOLDER_INTO_ITSELF"] = 5] = "MOVE_FOLDER_INTO_ITSELF";
    /**
     * A move into a non-existent backup device.
     *
     * @generated from enum value: MOVE_TO_INVALID_MOUNTPOINT = 6;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_TO_INVALID_MOUNTPOINT"] = 6] = "MOVE_TO_INVALID_MOUNTPOINT";
    /**
     * Moved a shared folder into another shared folder
     *
     * @generated from enum value: MOVE_SHARE_ONTO_SHARE = 7;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_SHARE_ONTO_SHARE"] = 7] = "MOVE_SHARE_ONTO_SHARE";
    /**
     * Moved file into a read-only path.
     *
     * @generated from enum value: MOVE_TO_READ_ONLY = 10;
     */
    MoveResponse_MoveError[MoveResponse_MoveError["MOVE_TO_READ_ONLY"] = 10] = "MOVE_TO_READ_ONLY";
})(MoveResponse_MoveError || (MoveResponse_MoveError = {}));
// Retrieve enum metadata with: proto3.getEnumType(MoveResponse_MoveError)
proto3.util.setEnumType(MoveResponse_MoveError, "no.jotta.openapi.file.v2.MoveResponse.MoveError", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "MOVE_FOLDER_ONTO_FILE" },
    { no: 8, name: "MOVE_FOLDER_ONTO_FOLDER" },
    { no: 2, name: "MOVE_FILE_ONTO_FOLDER" },
    { no: 9, name: "MOVE_FILE_ONTO_FILE" },
    { no: 3, name: "MOVE_BETWEEN_USERS" },
    { no: 4, name: "MOVE_TO_FROM_ARE_EQUAL" },
    { no: 5, name: "MOVE_FOLDER_INTO_ITSELF" },
    { no: 6, name: "MOVE_TO_INVALID_MOUNTPOINT" },
    { no: 7, name: "MOVE_SHARE_ONTO_SHARE" },
    { no: 10, name: "MOVE_TO_READ_ONLY" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage
 */
export class MoveResponse_MoveErrorMessage extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.error
     */
    error = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "move_error", kind: "enum", T: proto3.getEnumType(MoveResponse_MoveError), oneof: "error" },
        { no: 2, name: "file_system_error", kind: "enum", T: proto3.getEnumType(FileSystemError), oneof: "error" },
    ]);
    static fromBinary(bytes, options) {
        return new MoveResponse_MoveErrorMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveResponse_MoveErrorMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveResponse_MoveErrorMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveResponse_MoveErrorMessage, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.CopyRequest
 */
export class CopyRequest extends Message {
    /**
     * @generated from field: string from_path = 1;
     */
    fromPath = "";
    /**
     * @generated from field: string to_path = 2;
     */
    toPath = "";
    /**
     * @generated from field: no.jotta.openapi.file.v2.CopyRequest.ConflictHandler conflict_handler = 3;
     */
    conflictHandler = CopyRequest_ConflictHandler.UNKNOWN;
    /**
     * @generated from field: bool supports_background_jobs = 4;
     */
    supportsBackgroundJobs = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.CopyRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "from_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "to_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "conflict_handler", kind: "enum", T: proto3.getEnumType(CopyRequest_ConflictHandler) },
        { no: 4, name: "supports_background_jobs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new CopyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CopyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CopyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CopyRequest, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.CopyRequest.ConflictHandler
 */
export var CopyRequest_ConflictHandler;
(function (CopyRequest_ConflictHandler) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    CopyRequest_ConflictHandler[CopyRequest_ConflictHandler["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Rejecting conflicts in path names is the default
     *
     * @generated from enum value: REJECT_CONFLICTS = 1;
     */
    CopyRequest_ConflictHandler[CopyRequest_ConflictHandler["REJECT_CONFLICTS"] = 1] = "REJECT_CONFLICTS";
    /**
     * Creates a new name that is unique when the to_path already exists.
     *
     * @generated from enum value: CREATE_NEW_NAME = 2;
     */
    CopyRequest_ConflictHandler[CopyRequest_ConflictHandler["CREATE_NEW_NAME"] = 2] = "CREATE_NEW_NAME";
    /**
     * Copy the latest revision from from_path onto to_path.
     *
     * @generated from enum value: CREATE_NEW_REVISION = 3;
     */
    CopyRequest_ConflictHandler[CopyRequest_ConflictHandler["CREATE_NEW_REVISION"] = 3] = "CREATE_NEW_REVISION";
})(CopyRequest_ConflictHandler || (CopyRequest_ConflictHandler = {}));
// Retrieve enum metadata with: proto3.getEnumType(CopyRequest_ConflictHandler)
proto3.util.setEnumType(CopyRequest_ConflictHandler, "no.jotta.openapi.file.v2.CopyRequest.ConflictHandler", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "REJECT_CONFLICTS" },
    { no: 2, name: "CREATE_NEW_NAME" },
    { no: 3, name: "CREATE_NEW_REVISION" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.CopyResponse
 */
export class CopyResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.CopyResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.CopyResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path_item", kind: "message", T: PathItem, oneof: "result" },
        { no: 2, name: "background_job", kind: "message", T: BackgroundJob, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new CopyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CopyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CopyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CopyResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.file.v2.CopyResponse.CopyError
 */
export var CopyResponse_CopyError;
(function (CopyResponse_CopyError) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Copied folder into a path that is already a file.
     *
     * @generated from enum value: COPY_FOLDER_ONTO_FILE = 1;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_FOLDER_ONTO_FILE"] = 1] = "COPY_FOLDER_ONTO_FILE";
    /**
     * Copied folder into a path that is already a folder.
     *
     * @generated from enum value: COPY_FOLDER_ONTO_FOLDER = 7;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_FOLDER_ONTO_FOLDER"] = 7] = "COPY_FOLDER_ONTO_FOLDER";
    /**
     * Copied file into a path where a folder already exists.
     *
     * @generated from enum value: COPY_FILE_ONTO_FOLDER = 2;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_FILE_ONTO_FOLDER"] = 2] = "COPY_FILE_ONTO_FOLDER";
    /**
     * Copied file into a path where a file already exists.
     *
     * @generated from enum value: COPY_FILE_ONTO_FILE = 8;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_FILE_ONTO_FILE"] = 8] = "COPY_FILE_ONTO_FILE";
    /**
     * Copy between users in an unsupported way.
     *
     * @generated from enum value: COPY_BETWEEN_USERS = 3;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_BETWEEN_USERS"] = 3] = "COPY_BETWEEN_USERS";
    /**
     * The paths given are equal.
     *
     * @generated from enum value: COPY_TO_FROM_ARE_EQUAL = 4;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_TO_FROM_ARE_EQUAL"] = 4] = "COPY_TO_FROM_ARE_EQUAL";
    /**
     * A recursive copy into itself is unsupported.
     *
     * @generated from enum value: COPY_FOLDER_INTO_ITSELF = 5;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_FOLDER_INTO_ITSELF"] = 5] = "COPY_FOLDER_INTO_ITSELF";
    /**
     * A copy into a non-existent backup device.
     *
     * @generated from enum value: COPY_TO_INVALID_MOUNTPOINT = 6;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_TO_INVALID_MOUNTPOINT"] = 6] = "COPY_TO_INVALID_MOUNTPOINT";
    /**
     * A copy into a read-only path.
     *
     * @generated from enum value: COPY_TO_READ_ONLY = 9;
     */
    CopyResponse_CopyError[CopyResponse_CopyError["COPY_TO_READ_ONLY"] = 9] = "COPY_TO_READ_ONLY";
})(CopyResponse_CopyError || (CopyResponse_CopyError = {}));
// Retrieve enum metadata with: proto3.getEnumType(CopyResponse_CopyError)
proto3.util.setEnumType(CopyResponse_CopyError, "no.jotta.openapi.file.v2.CopyResponse.CopyError", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "COPY_FOLDER_ONTO_FILE" },
    { no: 7, name: "COPY_FOLDER_ONTO_FOLDER" },
    { no: 2, name: "COPY_FILE_ONTO_FOLDER" },
    { no: 8, name: "COPY_FILE_ONTO_FILE" },
    { no: 3, name: "COPY_BETWEEN_USERS" },
    { no: 4, name: "COPY_TO_FROM_ARE_EQUAL" },
    { no: 5, name: "COPY_FOLDER_INTO_ITSELF" },
    { no: 6, name: "COPY_TO_INVALID_MOUNTPOINT" },
    { no: 9, name: "COPY_TO_READ_ONLY" },
]);
/**
 * @generated from message no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage
 */
export class CopyResponse_CopyErrorMessage extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.error
     */
    error = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "copy_error", kind: "enum", T: proto3.getEnumType(CopyResponse_CopyError), oneof: "error" },
        { no: 2, name: "file_system_error", kind: "enum", T: proto3.getEnumType(FileSystemError), oneof: "error" },
    ]);
    static fromBinary(bytes, options) {
        return new CopyResponse_CopyErrorMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CopyResponse_CopyErrorMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CopyResponse_CopyErrorMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CopyResponse_CopyErrorMessage, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.DeleteRequest
 */
export class DeleteRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: bool supports_background_jobs = 2;
     */
    supportsBackgroundJobs = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.DeleteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "supports_background_jobs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new DeleteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.DeleteResponse
 */
export class DeleteResponse extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
     */
    backgroundJob;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.DeleteResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "background_job", kind: "message", T: BackgroundJob, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new DeleteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.RestoreRequest
 */
export class RestoreRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: bool supports_background_jobs = 2;
     */
    supportsBackgroundJobs = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.RestoreRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "supports_background_jobs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new RestoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.RestoreResponse
 */
export class RestoreResponse extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
     */
    backgroundJob;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.RestoreResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "background_job", kind: "message", T: BackgroundJob, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new RestoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.DeletePermanentlyRequest
 */
export class DeletePermanentlyRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: bool supports_background_jobs = 2;
     */
    supportsBackgroundJobs = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.DeletePermanentlyRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "supports_background_jobs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new DeletePermanentlyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePermanentlyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePermanentlyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePermanentlyRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.DeletePermanentlyResponse
 */
export class DeletePermanentlyResponse extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
     */
    backgroundJob;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.DeletePermanentlyResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "background_job", kind: "message", T: BackgroundJob, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new DeletePermanentlyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePermanentlyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePermanentlyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePermanentlyResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListRevisionsRequest
 */
export class ListRevisionsRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListRevisionsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ListRevisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRevisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRevisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRevisionsRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListRevisionsResponse
 */
export class ListRevisionsResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.file.v2.FileRevision revisions = 1;
     */
    revisions = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListRevisionsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "revisions", kind: "message", T: FileRevision, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListRevisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRevisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRevisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRevisionsResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.SimpleFile
 */
export class SimpleFile extends Message {
    /**
     * @generated from field: string name = 1;
     */
    name = "";
    /**
     * @generated from field: string path = 2;
     */
    path = "";
    /**
     * @generated from field: string checksum = 3;
     */
    checksum = "";
    /**
     * @generated from field: int64 modified_at_millis = 4;
     */
    modifiedAtMillis = protoInt64.zero;
    /**
     * @generated from field: int64 deleted_at_millis = 5;
     */
    deletedAtMillis = protoInt64.zero;
    /**
     * @generated from field: int64 size = 6;
     */
    size = protoInt64.zero;
    /**
     * @generated from field: string owner = 7;
     */
    owner = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.SimpleFile";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "checksum", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "modified_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 5, name: "deleted_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 6, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 7, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SimpleFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimpleFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimpleFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimpleFile, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.Item
 */
export class Item extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.Item.item
     */
    item = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.Item";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder", kind: "message", T: SimpleFolder, oneof: "item" },
        { no: 2, name: "file", kind: "message", T: SimpleFile, oneof: "item" },
    ]);
    static fromBinary(bytes, options) {
        return new Item().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Item().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Item().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Item, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.SimpleFolder
 */
export class SimpleFolder extends Message {
    /**
     * @generated from field: string name = 1;
     */
    name = "";
    /**
     * @generated from field: string path = 2;
     */
    path = "";
    /**
     * @generated from field: int64 deleted_at_millis = 3;
     */
    deletedAtMillis = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.SimpleFolder";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "deleted_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new SimpleFolder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimpleFolder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimpleFolder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimpleFolder, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListFolderRequest
 */
export class ListFolderRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: bool include_deleted = 2;
     */
    includeDeleted = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListFolderRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "include_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListFolderResponse
 */
export class ListFolderResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.SimpleFolder folder = 1;
     */
    folder;
    /**
     * @generated from field: repeated no.jotta.openapi.file.v2.Item children = 2;
     */
    children = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListFolderResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder", kind: "message", T: SimpleFolder },
        { no: 2, name: "children", kind: "message", T: Item, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListFolderItemResponse
 */
export class ListFolderItemResponse extends Message {
    /**
     * how to model the root folder we asked for in the request?
     *
     * @generated from field: no.jotta.openapi.file.v2.Item item = 1;
     */
    item;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListFolderItemResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "item", kind: "message", T: Item },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderItemResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListFolderStats
 */
export class ListFolderStats extends Message {
    /**
     * @generated from field: int64 folder_count = 1;
     */
    folderCount = protoInt64.zero;
    /**
     * @generated from field: int64 file_count = 2;
     */
    fileCount = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListFolderStats";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 2, name: "file_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderStats, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListFolderItemStreamResponse
 */
export class ListFolderItemStreamResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.file.v2.ListFolderItemStreamResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListFolderItemStreamResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "item", kind: "message", T: Item, oneof: "result" },
        { no: 2, name: "stats", kind: "message", T: ListFolderStats, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderItemStreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderItemStreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderItemStreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderItemStreamResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.ListFolderStreamRequest
 */
export class ListFolderStreamRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: bool recursive = 2;
     */
    recursive = false;
    /**
     * @generated from field: bool include_deleted = 3;
     */
    includeDeleted = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.ListFolderStreamRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "include_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderStreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderStreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderStreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderStreamRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.RecentFilesRequest
 */
export class RecentFilesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.RecentFilesRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new RecentFilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecentFilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecentFilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecentFilesRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.file.v2.RecentFilesResponse
 */
export class RecentFilesResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.file.v2.PathItem items = 1;
     */
    items = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.file.v2.RecentFilesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "items", kind: "message", T: PathItem, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new RecentFilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecentFilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecentFilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecentFilesResponse, a, b);
    }
}
